import HTTP_METHODS from "src/general/constants/http/httpMethods";
import {
	AuthGetRequest as Req,
	AuthGetResponse as Res,
} from "src/business.InterfaceLayer/store/entities/auth.entity/redux/api/types/GET";
import { createBaseQueryDefinition } from "src/business.InterfaceLayer/store/services/utils.service/ResponseTransforms";
import MAIN_PATHS from "src/business.InterfaceLayer/store/mainPaths";
import { ApiQueryBuilder } from "src/business.InterfaceLayer/store/types/ApiQueryBuilder.type";
import AUTH_PATHS from "src/business.InterfaceLayer/store/entities/auth.entity/redux/paths";
import { AuthFromDtoGet as Dto } from "src/business.InterfaceLayer/store/entities/auth.entity/services/dto/from.dto";
import { Nullable } from "../../../../../types/Nullable.type";

const getRequestBaseDefinition = createBaseQueryDefinition(
	HTTP_METHODS.GET,
	MAIN_PATHS.PROFILE
);

const authApiGetQueries = (build: ApiQueryBuilder) => ({
	getMe: build.query<Nullable<Res.AuthGetMe>, Req.AuthGetMe>({
		query: (params) => ({
			...getRequestBaseDefinition({ path: AUTH_PATHS.GET_ME, params }),
		}),
		transformResponse: Dto.authGetMeFromDto,
		providesTags: [`${MAIN_PATHS.AUTHORIZATION}TAG`],
	}),
});

export default authApiGetQueries;
